import { Action } from '@ngrx/store';
import { ContactUs } from '@eview/core/models/contact-us';

export enum EContactUsActions {
    ContactUsPost = '[Posts] Contact us',
    ContactUsSuccess = '[Posts] Contact us success',
    ContactUsFailure = '[Posts] Contact us failure'
}

export class ContactUsPost implements Action {
    readonly type = EContactUsActions.ContactUsPost;
    constructor(public payload: ContactUs) { }
}

export class ContactUsSuccess implements Action {
    readonly type = EContactUsActions.ContactUsSuccess;
}

export class ContactUsFailure implements Action {
    readonly type = EContactUsActions.ContactUsFailure;
}

export type ContactUsActions = ContactUsPost | ContactUsSuccess | ContactUsFailure;
